'use client'

import { createContext, useContext, ReactNode } from 'react'
import { useAuth } from '../hooks/use-auth'
import { UserData, LoginData, LoginResponse } from '../types/utils'

interface AuthContextType {
  user: UserData | null
  isAuthenticated: boolean
  isLoading: boolean
  token: string | null
  login: (data: LoginData) => Promise<LoginResponse>
  logout: () => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuth()

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuthContext() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider')
  }
  return context
}